export enum UserMessageStatus {
  SCHEDULED = 'SCHEDULED',
  PROCESSING = 'PROCESSING',
  RETRYING = 'RETRYING',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  UNDELIVERED = 'UNDELIVERED',
  SEND_FAILED = 'SEND_FAILED',
  CANCELLED = 'CANCELLED',
}
